export function set_order(order_data) {
    return {
        type: "@orders/SETORDER",
        payload: order_data
    };
}
